import { InferResult } from 'kysely';
import {
  orderJobsQueryBuilder,
  OrderJobsQueryBuilderPagedParams,
} from './orderJobsQueryBuilder';

export type OrderSetJobsStatsRows = InferResult<
  ReturnType<typeof getOrderSetJobsStatsQuery>
>;
export type OrderSetJobsStatsRow = OrderSetJobsStatsRows[number];
export type OrderSetJobsStatsColumn = keyof OrderSetJobsStatsRow;

export function getOrderSetJobsStatsQuery(
  params: OrderJobsQueryBuilderPagedParams,
) {
  let builder = orderJobsQueryBuilder(params)
    .with(
      cte => cte('picklist_aggregated'),
      db => {
        return db
          .selectFrom('order_line_job')
          .select(({ fn }) => [
            'picklistId',
            'orderLineRuleId',
            fn.count<number>('orderKey').distinct().as('affectedOrdersCount'),
            fn.avg<number>('totalNetWeight').as('totalNetWeight'),
            fn.avg<number>('totalVolume').as('totalVolume'),
          ])
          .groupBy(['orderLineRuleId', 'picklistId']);
      },
    )
    .selectFrom('picklist_aggregated')
    .select(({ fn }) => [
      'orderLineRuleId',
      'affectedOrdersCount',
      fn.countAll<number>().as('picklistCount'),
      fn.sum<number>('totalNetWeight').as('totalNetWeight'),
      fn.sum<number>('totalVolume').as('totalVolume'),
    ])
    .groupBy(['orderLineRuleId', 'affectedOrdersCount'])
    .orderBy(['orderLineRuleId', 'affectedOrdersCount']);
  return builder;
}
